import { Autocomplete, Chip, TextField } from '@mui/material';
import type { OfficialSourceOption } from '@/components/review/officialSource';

interface Props {
  options: OfficialSourceOption[];
  value: number[];
  onChange: (userIds: number[]) => void;
  ownerId?: number;
  currentUserId?: number | null;
  label?: string;
  helperText?: string;
  placeholder?: string;
}

function displayLabel(
  opt: OfficialSourceOption,
  ownerId: number,
  currentUserId?: number | null
): string {
  if (currentUserId != null && Number(opt.user_id) === Number(currentUserId)) return '您';
  if (ownerId && opt.user_id === ownerId) return `${opt.label}（預設）`;
  return opt.label;
}

export default function OfficialSourceMultiSelect({
  options,
  value,
  onChange,
  ownerId = 0,
  currentUserId,
  label = '官方判決來源',
  helperText = '可選擇多位群組成員的標記作為官方判決（未選時預設為影片擁有者）',
  placeholder = '搜尋成員姓名或編號…',
}: Props) {
  const selectedOptions = options.filter((opt) => value.includes(opt.user_id));

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={options}
      value={selectedOptions}
      onChange={(_, next) => onChange(next.map((opt) => opt.user_id))}
      getOptionLabel={(opt) => displayLabel(opt, ownerId, currentUserId)}
      isOptionEqualToValue={(a, b) => a.user_id === b.user_id}
      filterSelectedOptions
      noOptionsText="找不到符合的成員"
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={value.length === 0 ? placeholder : undefined}
          helperText={helperText}
        />
      )}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((opt, index) => (
          <Chip
            {...getTagProps({ index })}
            key={opt.user_id}
            size="small"
            label={displayLabel(opt, ownerId, currentUserId)}
          />
        ))
      }
      renderOption={(props, opt) => {
        const { key, ...rest } = props;
        return (
          <li key={key} {...rest}>
            {displayLabel(opt, ownerId, currentUserId)}
          </li>
        );
      }}
      slotProps={{
        paper: { sx: { maxHeight: 280 } },
      }}
      sx={{ width: '100%' }}
    />
  );
}
